mtl.alloy.factory.startDownload = (function($) {
    'use strict';

    /**
     * Automatically Follow the link after a short delay.
     */
    return function(element, options) {

        var delay = 2000; // 2 seconds

        setTimeout(function() {

            var href = element.href;
            if (href == null) {
                return;
            }

            window.location = href + '';

        }, delay);

    };

}(jQuery));
